var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 14 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.852 17.234h8.296c1.618 0 2.422-.82 2.422-2.445V7.695c0-1.008-.117-1.445-.742-2.086L8.523 1.227C7.93.617 7.438.484 6.563.484H2.852C1.242.484.43 1.313.43 2.938v11.851c0 1.633.804 2.445 2.422 2.445m.054-1.257c-.804 0-1.219-.43-1.219-1.211V2.96c0-.773.415-1.219 1.227-1.219h3.477v4.54c0 .984.492 1.468 1.468 1.468h4.454v7.016c0 .78-.415 1.21-1.227 1.21zM8 6.57c-.312 0-.43-.125-.43-.437V1.984l4.5 4.586z"
  })));
};
export default SvgFile;